"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MAX_VISIBILITY_EVENTS_CAPTURED = 10;
var VisibilityEvent = (function () {
    function VisibilityEvent(eventTime, isVisible) {
        this.eventTime = eventTime;
        this.isVisible = isVisible;
    }
    return VisibilityEvent;
}());
var WebsiteLivenessTracker = (function () {
    function WebsiteLivenessTracker(window) {
        this.window = window;
        var document = window.document;
        // Set the name of the hidden property and the change event for visibility
        var hidden, visibilityChange;
        if (typeof document.hidden !== "undefined") {
            hidden = "hidden";
            visibilityChange = "visibilitychange";
        }
        else if (typeof document.msHidden !== "undefined") {
            hidden = "msHidden";
            visibilityChange = "msvisibilitychange";
        }
        else if (typeof document.webkitHidden !== "undefined") {
            hidden = "webkitHidden";
            visibilityChange = "webkitvisibilitychange";
        }
        this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
        // Warn if the browser doesn't support addEventListener or the Page Visibility API
        if (typeof document.addEventListener === "undefined" || typeof document.hidden === "undefined") {
            console.log("WorkDocs web client metrics are not supported for your browser. Please use most current browser such as Google Chrome or Firefox, that supports the Page Visibility API.");
        }
        else {
            // Handle page visibility change
            document.addEventListener(visibilityChange, this.handleVisibilityChange, false);
        }
        this.hiddenPropName = hidden;
        this.visibilityChangeEventName = visibilityChange;
        this.visibilityEvents = [];
        //Artificial firing to make a first entry
        this.handleVisibilityChange();
    }
    WebsiteLivenessTracker.prototype.destroy = function () {
        var document = this.window.document;
        document.removeEventListener(this.visibilityChangeEventName, this.handleVisibilityChange);
    };
    WebsiteLivenessTracker.prototype.getPageVisibilityDuringPeriod = function (startTime, endTime) {
        var document = this.window.document;
        if (typeof document[this.hiddenPropName] === 'undefined') {
            //This browser does not support page visibility. Hence return false for reliability sake.
            return false;
        }
        var length = this.visibilityEvents.length;
        var startIndex = -1, endIndex = -1;
        for (var i = 0; i < length; i++) {
            var event_1 = this.visibilityEvents[i];
            if (event_1.eventTime <= startTime) {
                startIndex = i;
                break;
            }
        }
        //We do not know the state of the system before we started capturing, safely return false
        if (startIndex === -1) {
            return false;
        }
        for (var i = 0; i < length; i++) {
            var event_2 = this.visibilityEvents[i];
            if (event_2.eventTime < endTime) {
                endIndex = i;
                break;
            }
        }
        //This means the state didn't change
        if (endIndex === -1) {
            var event_3 = this.visibilityEvents[startIndex];
            return event_3.isVisible;
        }
        //If we reach this point, endIndex and startIndex have changed from default
        //Let's iterate in reverse order
        for (var i = startIndex; i >= endIndex; i--) {
            var event_4 = this.visibilityEvents[i];
            if (!event_4.isVisible) {
                return false;
            }
        }
        return true;
    };
    WebsiteLivenessTracker.prototype.handleVisibilityChange = function () {
        var console = this.window.console;
        var document = this.window.document;
        var performance = this.window.performance;
        if (document[this.hiddenPropName]) {
            this.visibilityEvents.unshift(new VisibilityEvent(performance.now(), false));
        }
        else {
            this.visibilityEvents.unshift(new VisibilityEvent(performance.now(), true));
        }
        if (this.visibilityEvents.length > MAX_VISIBILITY_EVENTS_CAPTURED) {
            //Always truncate array to max items we can capture
            this.visibilityEvents.length = MAX_VISIBILITY_EVENTS_CAPTURED;
        }
    };
    return WebsiteLivenessTracker;
}());
exports.default = WebsiteLivenessTracker;
